import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { QuoteContext } from "@/quote-context";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Trust } from "@/components/site/Trust";
import { Services } from "@/components/site/Services";
import { WhyUs } from "@/components/site/WhyUs";
import { EmergencyCTA } from "@/components/site/EmergencyCTA";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Reviews } from "@/components/site/Reviews";
import { ServiceArea } from "@/components/site/ServiceArea";
import { About } from "@/components/site/About";
import { Faq } from "@/components/site/Faq";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Footer } from "@/components/site/Footer";
import { QuoteDialog } from "@/components/site/QuoteDialog";
import { MobileCallBar } from "@/components/site/MobileCallBar";

function App() {
    const [quoteOpen, setQuoteOpen] = useState(false);
    const [quoteService, setQuoteService] = useState("");

    const openQuote = (service = "") => {
        setQuoteService(service);
        setQuoteOpen(true);
    };

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <QuoteContext.Provider value={{ openQuote }}>
            <div className="min-h-screen bg-white">
                <Header />
                <main>
                    <Hero />
                    <Marquee />
                    <Trust />
                    <Services />
                    <WhyUs />
                    <EmergencyCTA />
                    <HowItWorks />
                    <Reviews />
                    <ServiceArea />
                    <About />
                    <Faq />
                    <FinalCTA />
                </main>
                <Footer />
                <MobileCallBar />
                <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} service={quoteService} />
                <Toaster position="top-center" richColors />
            </div>
        </QuoteContext.Provider>
    );
}

export default App;
